import { components } from "@certn/api/generated-schemas/client-portal";

import { OrderingCheckListChild } from "../components/ordering-check-card/types";

type UmbrellaOption = components["schemas"]["UmbrellaCheckSelectOption"];

type CatalogMinimumCheck = {
  price_is_catalog_minimum?: boolean;
  children?: OrderingCheckListChild[];
};

export function getExplicitOptionChildType(
  option: UmbrellaOption
): string | undefined {
  const raw = option.value;
  if (Array.isArray(raw)) {
    return raw[0] != null ? String(raw[0]) : undefined;
  }
  return raw != null ? String(raw) : undefined;
}

export function resolvePriceIsCatalogMinimum(
  check: CatalogMinimumCheck,
  selectedOption?: UmbrellaOption
): boolean {
  if (selectedOption?.price_is_catalog_minimum) {
    return true;
  }

  const childType = selectedOption
    ? getExplicitOptionChildType(selectedOption)
    : undefined;
  if (childType) {
    const child = check.children?.find((c) => c.type === childType);
    if (child != null) {
      return !!child.price_is_catalog_minimum;
    }
  }

  if (selectedOption?.price_is_catalog_minimum === false) {
    return false;
  }

  return !!check.price_is_catalog_minimum;
}

export function resolvePriceIsCatalogMinimumFromOptions(
  check: CatalogMinimumCheck,
  selectedOptions?: UmbrellaOption[]
): boolean {
  if (!selectedOptions?.length) {
    return resolvePriceIsCatalogMinimum(check);
  }

  return selectedOptions.some((option) =>
    resolvePriceIsCatalogMinimum(check, option)
  );
}

export function resolveOptionPriceIsCatalogMinimum(
  option: UmbrellaOption,
  checkChildren: OrderingCheckListChild[] | undefined,
  parentPriceIsCatalogMinimum?: boolean
): boolean {
  return resolvePriceIsCatalogMinimum(
    {
      price_is_catalog_minimum: parentPriceIsCatalogMinimum,
      children: checkChildren,
    },
    option
  );
}
